module.exports = __webpack_public_path__ + "img/error.d7120d3c.png";